import { Placeholder } from '@s4l/ds'
import React from 'react'

function RadioItemPlaceholder({ lines = 2 }: { lines?: number }) {
  return <Placeholder.Text lines={lines} />
}

RadioItemPlaceholder.displayName = 'RadioItemPlaceholder'

export default RadioItemPlaceholder
